import { render, staticRenderFns } from "./VaccinationList.vue?vue&type=template&id=10065ccb&"
import script from "./VaccinationList.vue?vue&type=script&lang=js&"
export * from "./VaccinationList.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports